import React, { Component } from "react";
// import loader from "./dual-ring-loader.svg";

class LoadingAnimationV2 extends Component {
    render() {

        if (this.props.isLoading === false) {
            return null;
        }

        return (
            <div className=" loader-container">
                <svg className="q-spinner text-primary q-spinner-mat" 
                    width={"100"} height={"100"} viewBox="25 25 50 50">
                    <circle className="path" cx="50" cy="50" r="20" fill="none" stroke={"#147ac6"} 
                        stroke-width="5" stroke-miterlimit="10">
                    </circle>
                </svg>
                {/* <svg xmlns="http://www.w3.org/2000/svg" 
                    width={"100"} 
                    height={"100"}  
                    display="block" preserveAspectRatio="xMidYMid" 
                    style={{margin:'auto',background:'#fff', borderRadius: '10%'}} 
                    viewBox="0 0 100 100">

                    <circle cx="50" cy="50" r="30" fill="none" 
                        stroke={"#147ac6"} 
                        strokeDasharray="77 17" strokeLinecap="round" strokeWidth="3">
                        <animateTransform attributeName="transform" 
                            dur="1s" 
                            keyTimes="0;1" 
                            repeatCount="indefinite" 
                            type="rotate" 
                            values="0 50 50;360 50 50"
                        />
                    </circle>
                </svg> */}
            </div>
        );
    }
}

export default LoadingAnimationV2;


// WEBPACK FOOTER //
// ./src/LoadingAnimationV2.js